export function resolveOidcBrowserRouting(
  publicUrl: string,
  issuer: string,
  browserProxyEnabled: boolean,
  browserProxyBasePath: string,
  jwksCacheKey = '',
) {
  const cacheSuffix = jwksCacheKey ? `?cache=${encodeURIComponent(jwksCacheKey)}` : '';
  if (!browserProxyEnabled) {
    return {
      wellKnownEndpointUrl: `${issuer}/.well-known/openid-configuration`,
      wellKnownEndpoints: {
        jwksUri: `${issuer}/.well-known/jwks.json${cacheSuffix}`,
      },
      strictIssuerValidationOff: false,
    };
  }
  const proxyUrl = new URL(browserProxyBasePath, publicUrl).toString().replace(/\/$/, '');
  return {
    wellKnownEndpointUrl: `${proxyUrl}/.well-known/openid-configuration`,
    wellKnownEndpoints: {
      issuer,
      jwksUri: `${proxyUrl}/.well-known/jwks.json${cacheSuffix}`,
      authorizationEndpoint: `${issuer}/oidc/authorize`,
      tokenEndpoint: `${proxyUrl}/oidc/token`,
      userInfoEndpoint: `${proxyUrl}/oidc/userinfo`,
      endSessionEndpoint: `${issuer}/oidc/logout`,
      revocationEndpoint: `${proxyUrl}/oidc/revoke`,
    },
    strictIssuerValidationOff: true,
  };
}
